import React, { useRef, useState } from 'react';

import { useAuth } from '../../contexts/AuthContext';

import { Link, useHistory } from 'react-router-dom';

import '../../styles/SignUp.css';
import Alert from '../Alert';

const SignUp = () => {
  const emailRef = useRef();
  const passwordRef = useRef();

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const { login, loginWithGoogle } = useAuth();

  const handleSubmit = async (ev) => {
    ev.preventDefault();

    const email = emailRef.current.value;
    const password = passwordRef.current.value;

    if (password.length < 6) {
      return setError('Password too small');
    }

    try {
      setLoading(true);
      setError('');
      await login(email, password);
      history.push('/');
    } catch (err) {
      setError('Failed to Login');
    }

    setLoading(false);
  };

  const handleGoogleSignIn = async () => {
    try {
      setError('');
      await loginWithGoogle();
      history.push('/');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="card">
      <h1>Login</h1>
      <hr className="horizontal-rule" />
      {error && <Alert variant="error">{error}</Alert>}
      <button className="google-sign-btn btn" onClick={handleGoogleSignIn}>
        Sign in with Google <div className="google-icon"></div>
      </button>

      <form className="form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            className="input-field"
            type="email"
            name="email"
            required
            placeholder="mail@website.com"
            ref={emailRef}
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            className="input-field"
            type="password"
            name="password"
            required
            placeholder="Min. 6 character"
            ref={passwordRef}
          />
        </div>

        <button disabled={loading} className="cta-button btn" type="submit">
          Login
        </button>
      </form>

      <div className="login">
        <h4>
          Dont have an account ? <Link to="/signup">Create account</Link>
        </h4>
      </div>
      <div className="login">
        <h4>
          <Link to="/reset-password">Forgot your password ?</Link>
        </h4>
      </div>
    </div>
  );
};

export default SignUp;
